export class RepairsUpdatesCommentsPostRequest {
  comment!: string
  logId?: string
}
